/* Noah.Q v253: legacy homepage gate compatibility only.
   Adobe East Asian fonts are delivered by the JavaScript kit booted in the
   real document head. Do not alter wf-loading / wf-active here. */
(() => {
  'use strict';
  const root = document.documentElement;
  root.classList.remove('noahq-loading', 'noahq-home-fonts-loading');
  root.classList.add('noahq-home-fonts-ready');
})();
